module.exports = __webpack_public_path__ + "static/media/uplatnica.5e92e409.png";